export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12021.2cacf2bb.jpg";